import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { useBroker } from '../../../../../hooks/useBroker';
import { employmentOptions } from '../../config/globals';
import { EmploymentFormGroupData } from '../../FormData.se.types';
import { requiredField } from '../../steps/shared-config';

export const EmploymentStatusField = ({
  applicant = '',
}: {
  applicant?: '' | 'CoApplicant';
}) => {
  const { t } = useTranslation();

  const broker = useBroker();

  return (
    <DropdownFieldUI<EmploymentFormGroupData>
      name={`LoanApplication/${applicant}EmploymentStatus`}
      label={t('EmploymentStatus.label')}
      data-testid="employment-dropdown"
      options={employmentOptions[broker]}
      registerOptions={requiredField}
    />
  );
};
